export default "__VITE_PUBLIC_ASSET__e0423f67__"